import axios from 'axios';
import { DocumentRequest } from '@/store/bbva-document/types';

const getBbvaDocument = (documentRequest: DocumentRequest): Promise<any> => {
    const getBbvaDocumentUrl = '/api/kcc/application/document/';
    return axios.post(getBbvaDocumentUrl, documentRequest);
}

export {
    getBbvaDocument,
}